export function toTitle(raw) {
  if (!raw) return null;
  return {
    id: raw.Id || raw.id || raw.MovieId,
    title: raw.Title || raw.title || raw.Name || 'Untitled',
    description: raw.Description || raw.description || '',
    director: raw.Director || raw.director || '',
    cast: (raw.Cast || raw.cast || '')
      ? (Array.isArray(raw.Cast || raw.cast)
          ? (raw.Cast || raw.cast)
          : String(raw.Cast || raw.cast).split(',').map((s) => s.trim()).filter(Boolean))
      : [],
    year: raw.ReleaseYear || raw.year || (raw.CreatedAt ? new Date(raw.CreatedAt).getFullYear() : null),
    categoryId: raw.CategoryId || raw.categoryId || null,
    category: raw.CategoryName || raw.category || raw.Genre || '',
    // Full category membership (primary first). Falls back to the single primary category
    // for responses from older/unmigrated endpoints that don't send Categories yet.
    categories: (() => {
      const list = raw.Categories || raw.categories;
      if (Array.isArray(list) && list.length > 0) {
        return list
          .map((c) => ({ id: c.Id ?? c.id ?? null, name: c.Name || c.name || '' }))
          .filter((c) => c.name);
      }
      const primary = raw.CategoryName || raw.category || raw.Genre;
      return primary ? [{ id: raw.CategoryId ?? raw.categoryId ?? null, name: primary }] : [];
    })(),
    rating: raw.AgeRating || raw.Rating || raw.rating || raw.ContentRating || null,
    // Landscape 16:9 backdrop — hero banners, title page, "Continue Watching". Never the portrait poster.
    thumbnail: raw.ThumbnailUrl || raw.thumbnail || raw.BannerUrl || null,
    // Portrait 2:3 poster — catalogue rows & grids. Empty when the uploader didn't supply one;
    // TitleCard then falls back to the thumbnail.
    poster: raw.PosterUrl || raw.poster || null,
    trailer: raw.TrailerUrl || raw.trailer || null,
    episodeCount: raw.EpisodeCount || raw.episodeCount || 0,
    isSeries: raw.ContentType === 'Series' || raw.IsSeries || raw.isSeries || false,
    contentType: raw.ContentType || raw.contentType || (raw.IsSeries ? 'Series' : 'Movie'),
    isComingSoon: Boolean(raw.IsComingSoon || raw.isComingSoon),
    releaseDate: raw.ComingSoonReleaseDate || raw.releaseDate || null,
    likes: raw.LikeCount || raw.likes || 0,
    reactions: raw.Reactions || raw.reactions || {},
    resumeEpisodeId: raw._resumeEpisodeId || raw.EpisodeId || null,
    progressPercent: raw._progressPercent || raw.ProgressPercent || 0,
  };
}

export const toTitles = (items) => (Array.isArray(items) ? items : []).map(toTitle).filter(Boolean);

export function slugify(text) {
  if (!text) return '';
  return text
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/(^-|-$)/g, '');
}

export function toCategory(raw) {
  if (!raw) return null;
  const name = raw.Name || raw.name || '';
  return {
    id: raw.Id || raw.id,
    name,
    slug: slugify(name) || String(raw.Id || raw.id),
    image: raw.ImageUrl || raw.image || null,
    count: raw.MovieCount || raw.count || 0,
  };
}

const RAMP = [
  ['var(--ember)', 'var(--flame)'],
  ['var(--flame)', 'var(--magenta)'],
  ['var(--magenta)', 'var(--violet)'],
  ['var(--violet)', 'var(--electric)'],
  ['var(--electric)', 'var(--magenta)'],
];

export function genreInk(id) {
  return RAMP[Math.abs(Number(id) || 0) % RAMP.length];
}

export function genreGradient(id) {
  const [from, to] = genreInk(id);
  return `linear-gradient(135deg, ${from}, ${to})`;
}
